<template>
    <slot name="skills" >404 No Skills Information Found</slot>
</template>
<script>
export default {
    
}
</script>
<style scoped>
    
</style>